import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import Loading from 'src/components/Loading';
import { getSection } from 'src/hooks/useContentful/getSection';
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent';
import CardPlan from './CardPlan';
import contentfulClient from '../../../../services/contentful';
import {
  Container,
  ContainerPlan,
  Plans,
  Sorriso,
  Title,
} from './styles';
import Footer from './Footer';
import { useMiddlewareOffer } from 'src/hooks/useMiddlewareOffer';

function Planos() {
  const content = useFetchContent();
  const [loading, setLoading] = useState(false);
  const { data } = useMiddlewareOffer();

  const section = getSection({
    sectionName: 'landingDefaultPromo',
    data: content.data,
  });

  const typePlans = ['pedagiosEstacionamentos', 'estacionamentos', 'pedagios'];

  const plans = useQuery(
    'getCardPlan',
    () =>
      Promise.all(
        typePlans
          .filter((field) => Object.keys(section).includes(field))
          .map(
            async (field) =>
              await contentfulClient.getEntry(section[field].sys.id)
          )
      ),
    {
      enabled: content.data && !content.isLoading,
      retry: false,
    }
  );

  useEffect(() => {
    setLoading(plans.isLoading || content.isLoading);
  }, [plans.isLoading, content.isLoading]);


	useEffect(() => {
		setLoading(plans.isLoading || content.isLoading)
	}, [plans.isLoading, content.isLoading])

  if (loading || !plans.data) return <Loading />;
  return (
    <Container id='plans'>
      <Title>{section.title}</Title>
      <Sorriso />
      <ContainerPlan>
        <Plans size={plans.data.length}>
          {plans.data?.map((plan, index) => (
            <CardPlan item={plan} data={data} key={index} />
          ))}
        </Plans>
        <Footer
          buttonColor={section.corDoBotao}
          terms={section.regulamento}
          textColor={section.corTextoBotao}
          cupons={[
            plans.data[0].fields.firstButtonCoupon,
            plans.data[0].fields.secondButtonCoupon,
          ]}
        />
      </ContainerPlan>
    </Container>
  );
}
export default Planos;
